import { Card, CardContent, CardHeader, Stack } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { CopyButton } from '@components/CopyButton';
import DrilldownItem from '@components/DrilldownItem';

import { useSession } from '@hooks/useSession';

const messages = defineMessages({
  fhirPatientId: {
    id: 'GLOBAL.id.fhirPatient',
    defaultMessage: 'FHIR Patient ID',
  },
  vitallPatientId: {
    id: 'GLOBAL.id.vitallPatient',
    defaultMessage: 'Vitall Patient ID',
  },
  userId: {
    id: 'GLOBAL.id.user',
    defaultMessage: 'User ID',
  },
  accountId: {
    id: 'GLOBAL.id.account',
    defaultMessage: 'Account ID',
  },
});

export default function ClientIds() {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();

  const friendly_fhir_patient_id = activeProfile?.patient_id?.split('/').at(-1);

  return (
    <Card>
      <CardHeader title="Debug IDs" />
      <CardContent>
        <Stack>
          {activeProfile?.user_id && (
            <Stack direction="row" alignItems={'center'} spacing={0}>
              <DrilldownItem
                label={formatMessage(messages.userId)}
                readOnly
                value={activeProfile.user_id}
              />
              <CopyButton content={activeProfile.user_id} />
            </Stack>
          )}
          {activeProfile?.account_id && (
            <Stack direction="row" alignItems={'center'} spacing={0}>
              <DrilldownItem
                label={formatMessage(messages.accountId)}
                readOnly
                value={activeProfile.account_id}
              />
              <CopyButton content={activeProfile.account_id} />
            </Stack>
          )}
          {activeProfile?.vitall_patient_id && (
            <Stack direction="row" alignItems={'center'} spacing={0}>
              <DrilldownItem
                label={formatMessage(messages.vitallPatientId)}
                readOnly
                value={activeProfile.vitall_patient_id}
              />
              <CopyButton content={activeProfile.vitall_patient_id} />
            </Stack>
          )}
          {activeProfile?.patient_id && (
            <Stack direction="row" alignItems={'center'} spacing={0}>
              <DrilldownItem
                label={formatMessage(messages.fhirPatientId)}
                readOnly
                value={friendly_fhir_patient_id}
              />
              <CopyButton content={friendly_fhir_patient_id ?? ''} />
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
